module.exports = __webpack_public_path__ + "static/media/ranking_icon.2f0a76e5.svg";